module.exports = __webpack_public_path__ + "img/nr-one-customer-service.ce926615.png";